import { AppEventPayload, AllowedEvents } from '@wix/editor-platform-contexts';
import { PlatformSDKShape } from '../PlatformSDKShape';
import { BaseSDKShape } from '../BaseSDKShape';

// TODO: remove events shape and remove payload transformations
export class EventsSDKShape extends BaseSDKShape {
  async addEventListener(
    name: any,
    // TODO: fix types
    cb: (payload: AppEventPayload<AllowedEvents>) => void,
  ) {
    return (await this.getApplicationContext())
      .getEvents()
      .addEventListener(name, cb);
  }
}

export default new PlatformSDKShape(EventsSDKShape)
  .withPublicMethod('addEventListener')
  .build();
